// Japanese
export const ja = {
    weeklyRewards: '週間報酬まで',
    days: '日',
    hours: '時間',
    minutes: '分',
    seconds: '秒',
    authenticating: '認証中',
    verifyWallet: 'ウォレットを確認中です。お待ちください',
    authRequired: '認証が必要です',
    authFailed: '認証に失敗しました。もう一度お試しください。',
    points: 'ポイント',
    rank: 'ランク',
    of: '/',
    players: 'プレイヤー',
    weeklyTopPlayers: '今週のトッププレイヤー',
    thisWeekLeaderboard: '今週のリーダーボード',
    rankingsReset: 'ランキングは毎週日曜日のUTC午前0時にリセットされます',
    yourPoints: 'あなたのポイント',
    dailyRewardAvailable: 'デイリー報酬が利用可能です！',
    nextClaimAvailable: '次の受け取りまで：',
    claimDailyReward: 'デイリー報酬を受け取る',
    claiming: '受け取り中...',
    multiplier: '倍率',
    bonusPointsMultiplier: 'ボーナスポイント倍率',
    outOf: '/',
    loading: '読み込み中...',
    errorLoading: '読み込みエラー',
    noEntries: 'エントリーなし',
    leaderboard: 'リーダーボード',
    topPerformers: '選択期間のトップパフォーマー',
    week: '週',
    year: '年',
    tasks: 'タスク',
    rules: 'ルール',
    profile: 'プロフィール',
    comingSoon: '近日公開...',
    completedTasks: '完了した\nアクティビティ',
    dailyRewardsClaimed: '受け取ったデイリー報酬',
    times: '回',
    recentActivity: '最近のアクティビティ',
    noRewardsClaimed: 'まだ報酬を受け取っていません',
    dailyReward: 'デイリー報酬',
    howItWorks: '使い方',
    welcomeMessage:
        'Coinomi Rewardsへようこそ！様々なタスクを完了してポイントを獲得し、ランキングを上げましょう。',
    dailyRewardsTitle: 'デイリー報酬',
    dailyRewardsRules: [
        '24時間ごとにデイリー報酬を受け取れます',
        '1回の受け取りで100ポイント獲得',
        'ポイントは倍率によって増加します',
    ],
    multiplierBonusesTitle: '倍率ボーナス',
    multiplierBonusesRules: [
        '1倍から開始',
        'Telegramを連携で+10%ボーナス',
        'メール認証で+10%ボーナス',
        'ボーナスは最大報酬のために累積されます',
    ],
    leaderboardTitle: 'リーダーボード',
    leaderboardRules: [
        '他のプレイヤーと競争',
        'リーダーボードはリアルタイムで更新',
        'トッププレイヤーは特別な報酬を獲得',
    ],
    boostEarningsTitle: '獲得量を増やす',
    boostEarningsRules: [
        'チャレンジを完了してボーナスを獲得',
        'Telegramコミュニティに参加',
        '最大の報酬のためにアクティブを維持',
    ],
    challenges: 'チャレンジ',
    telegramChallenge: 'Telegramチャレンジ',
    emailChallenge: 'メールチャレンジ',
    connectTelegram: 'Telegramを連携',
    shareEmail: 'メールを共有',
    telegramSuccess:
        '🎉 おめでとうございます！すべての報酬に対して永続的な10%ボーナスを受け取れるようになりました！',
    telegramPrompt:
        'Telegramアカウントを連携して、すべての報酬に対して永続的な10%ボーナスを受け取りましょう！',
    emailSuccess:
        '🎉 おめでとうございます！すべての報酬に対して永続的な10%ボーナスを受け取れるようになりました！',
    emailPrompt: 'メールを共有して、すべての報酬に対して永続的な10%ボーナスを受け取りましょう！',
    connectEmail: 'メールを連携',
    cancel: 'キャンセル',
    emailPrivacy: 'メールアドレスは重要なアップデートと報酬の通知にのみ使用されます。',
    connectYourEmail: 'メールを連携する',
    emailBonus: '🎉 メールを連携して、すべての報酬に対して永続的な10%ボーナスを受け取りましょう！',
    enterValidEmail: '有効なメールアドレスを入力してください',
    emailAddress: 'メールアドレス',
    errorSavingEmail: 'メールの保存中にエラーが発生しました。もう一度お試しください。',
    claimButton: '受け取る',
    earnedReward: '獲得した報酬',
    rewardValue: '{{amount}}ポイント',
    claimingReward: '受け取り中...',
    claimSuccess: '{{amount}}ポイントを受け取りました！',
    claimError: '受け取りに失敗しました。もう一度お試しください。',
    privacyDisclaimer:
        'Coinomiは個人データを収集しません。サードパーティのシステムがポイントとソーシャル接続を安全に管理します。',
    streakBonus: 'ストリークボーナス',
    streakDays: '{{days}}/5日',
    streakBonusValue: '+{{percent}}%',
    streakMaxBonus: '+10%追加',
    streakDescription: '最大ボーナスのために5日連続で受け取りましょう',
    streakToday: '今日',
    streakMissed: '未達成',
    streakComplete: '完了',
    streakActive: 'アクティブなストリーク',
    streakLost: 'ストリーク失敗',
    streakNext: '次',
    home: 'ホーム',
    currentStreak: '現在のストリーク',
    totalClaims: '合計受け取り回数',
    userStats: 'あなたの統計',
    referrals: '紹介',
    referralProgram: '紹介プログラム',
    howReferralWorks: '紹介の仕組み：',
    referralSteps: [
        '友達と紹介リンクを共有',
        'あなたのリンクから参加すると、紹介者になります',
        'アクティブな紹介ごとにボーナスポイントを獲得',
        'ここで紹介と獲得状況を確認できます',
    ],
    referralRewards: '紹介ポイントの付与：',
    referralBonuses: ['紹介1件につき100ポイント', '紹介者が獲得したポイントの10%'],
    yourReferralLink: 'あなたの紹介リンク',
    copyToClipboard: 'クリップボードにコピー',
    linkCopied: 'リンクをコピーしました！',
    totalReferrals: '合計紹介数',
    yourReferralCode: 'あなたの紹介コード',
    referralCodeCopied: '紹介コードをコピーしました！',
    editReferralCode: '紹介コードを編集',
    editReferralCodeInstructions:
        '新しい紹介コードを選択してください。5文字以上で、文字と数字を含めることができます。',
    newReferralCode: '新しい紹介コード',
    referralCodeRequirements: '最低5文字、文字と数字のみ',
    updating: '更新中...',
    update: '更新',
    referralCodeTaken: 'この紹介コードは既に使用されています',
    haveReferralCode: '紹介コードをお持ちですか？',
    enterReferralCodePrompt:
        '誰かに紹介された場合は、アカウントを連携するためにここにコードを入力してください。',
    enterReferralCode: '紹介コードを入力',
    enterReferralCodeInstructions: '共有された紹介コードを入力してください。',
    referralCode: '紹介コード',
    referralCodeFormat: '文字と数字のみ',
    submitting: '送信中...',
    submit: '送信',
    enterCode: 'コードを入力',
    pleaseAddtoken: 'URLにトークンパラメータを追加してください',
    authenticationError: '認証中にエラーが発生しました',
    noUserFound: 'ユーザーが見つかりません',
    userNotFoundMessage: 'ユーザーデータが見つかりません',
    backToHome: 'ホームに戻る',
    retry: '再試行',
    baseMultiplier: '基本倍率',
    telegramBonus: 'Telegramボーナス',
    referralChallenge: '紹介チャレンジ',
    referralChallengePrompt:
        '友達を招待してボーナスポイントを獲得しましょう！紹介1件につき100ポイントと、紹介者の獲得ポイントの10%を獲得できます。',
    startReferring: '紹介を始める',
    referralSuccess:
        '🎉 おめでとうございます！ユーザーを紹介し、ボーナスポイントを獲得しています！',
    unranked: 'ランク外',
    noPlayersYet: '最初の参加者になりましょう！',
    shareVia: '共有方法',
    shareOn: '{{network}}で共有',
    shareInviteText:
        '🚀 @CoinomiWalletで無料の暗号通貨を稼いでいます！\n\ncoinomi.com/downloadsからCoinomiをダウンロードして、アプリで#Coinomi Rewardsに参加する際に私の紹介コード{{referralCode}}を入力してボーナスを獲得してください。',
    yourStatsThisWeek: '今週のあなたの統計',
    pointsMultiplier: 'ポイント倍率',
    yourRank: 'あなたのランク',
    rewards: '報酬',
    daily: '毎日',
    weekly: '毎週',
    claimRewards: '報酬を受け取る',
    player: 'プレイヤー',
    score: 'スコア',
    youHaveReferred_zero: 'まだ友達を招待していません',
    youHaveReferred_one: '1人の友達を招待しました',
    youHaveReferred_other: '{{count}}人の友達を招待しました',
    referYourFriends: '友達を招待',
    dailyRewardTooltip: '毎日ログインしてポイントと報酬を獲得しましょう',
    weeklyRewardTooltip: '報酬の配布は週単位で行われます',
    'new-referral': '新規紹介',
    'daily-reward': 'デイリー報酬',
    'referral-bonus': '紹介ボーナス',
    copy: 'コピー',
    // Twitter Challenge
    twitterChallenge: 'Twitterチャレンジ',
    connectTwitter: 'Twitterを接続',
    twitterSuccess: '🎉 おめでとうございます！すべての報酬に10%の恒久的なボーナスが付与されます！',
    twitterPrompt:
        'Twitterアカウントを接続して、すべての報酬に10%の恒久的なボーナスを獲得しましょう！',
    pleaseAddUserId: 'URLにuserIdパラメータを追加してください',
    emailChallengePrompt:
        'メールを共有して、すべての報酬に対して永続的な10%ボーナスを受け取りましょう！',
    emailChallengeSuccess:
        '🎉 接続されました！すべての報酬に対して永続的な10%ボーナスを受け取れるようになりました！',
    followKoalaWalletChallenge: 'サポートのためにTwitterで@coinomiWalletをフォローしてください！',
    twitterAuthSuccessTitle: 'Twitterが正常に接続されました！',
    twitterAuthSuccessMessage:
        'Twitterアカウントが正常に接続されました。アプリの利用を続けられます。',
    continueToApp: 'アプリに進む',
    twitter_like: 'ツイートをいいねしました',
    twitter_retweet: 'ツイートをリツイートしました',
    disconnect: '切断',
    followCoinomiWallet: 'Twitterで@coinomiWalletをフォローして応援しよう！',
    connectedBonus: '🎉 接続されました！すべての報酬に対して永久に10%のボーナスを受け取れます！',
};
